import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '@/layout'

/* Router Modules */
import chartsRouter from './modules/charts'
import tableRouter from './modules/table'
import { getToken, removeToken } from '@/utils/auth' // get token from cookie
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style

/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'/'el-icon-x' the icon show in the sidebar
    noCache: true                if set true, the page will no be cached(default is false)
    affix: true                  if set true, the tag will affix in the tags-view
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
 */

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export const constantRoutes = [
  {
    path: '/redirect',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/redirect/:path(.*)',
        component: () => import('@/views/redirect/index')
      }
    ]
  },
  {
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true
  },
  {
    path: '/auth-redirect',
    component: () => import('@/views/login/auth-redirect'),
    hidden: true
  },
  // {
  //   path: '/',
  //   component: Layout,
  //   redirect: '/dashboard',
  //   children: [
  //     {
  //       path: 'dashboard',
  //       component: () => import('@/views/dashboard/index'),
  //       name: '首页',
  //       meta: { title: '首页', icon: 'dashboard', affix: true }
  //     }
  //   ]
  // },
  {
    path: '/',
    component: Layout,
    redirect: '/userManager',
    hidden: false,
    children: [
      {
        path: 'userManager',
        component: () => import('@/views/userManager/index'),
        name: 'UserManager',
        meta: { title: '客户管理', roles: ['admin','editor'], icon: 'icon-yonghuguanli1', noCache: true }
      }
    ]
  }, {
    path: '/quotation',
    component: Layout,
    redirect: '/quotation/index',
    hidden: false,
    children: [
      {
        path: 'index',
        component: () => import('@/views/quotation/index'),
        name: 'quotation',
        meta: { title: '报价管理', roles: ['admin','editor'], icon: 'icon-baojia', noCache: true }
      }
    ]
  }, {
    path: '/staffManager',
    component: Layout,
    redirect: '/staffManager/index',
    hidden: false,
    children: [
      {
        path: 'index',
        component: () => import('@/views/staffManager/index'),
        name: 'StaffManager',
        meta: { title: '员工管理', roles: ['admin','editor'], icon: 'icon-yonghuguanli1', noCache: true }
      }
    ]
  }, {
    path: '/packers',
    component: Layout,
    redirect: '/packers/index',
    hidden: false,
    children: [
      {
        path: 'index',
        component: () => import('@/views/packers/index'),
        name: 'Packers',
        meta: { title: '施工工队管理', roles: ['admin','editor'], icon: 'icon-shigongduiwuguanli', noCache: true }
      }
    ]
  },
  {
    path: '/constructionSite',
    component: Layout,
    redirect: '/constructionSite/index',
    hidden: false,
    children: [
      {
        path: 'index',
        component: () => import('@/views/constructionSite/index'),
        name: 'ConstructionSite',
        meta: { title: '在施工地管理', roles: ['admin','editor'], icon: 'icon-shigongdi', noCache: true }
      },
      {
        path: 'createEditSite',
        component: () => import('@/views/constructionSite/createEditSite'),
        name: 'CreateEditSite',
        meta: { title: '编辑在施工地', roles: ['admin','editor'], icon: 'icon-shigongdi', noCache: true }, 
        hidden: true
      }
    ]
  }, {
    path: '/3dManager',
    component: Layout,
    redirect: '/3dManager/index',
    hidden: false,
    children: [
      {
        path: 'index',
        component: () => import('@/views/3dManager/index'),
        name: '3dManager',
        meta: { title: '落地实景管理', roles: ['admin','editor'], icon: 'icon-D', noCache: true }
      }
    ]
  }, 
  {
    path: '/CoBranding',
    component: Layout,
    redirect: '/CoBranding/index',
    hidden: false,
    children: [
      {
        path: 'index',
        component: () => import('@/views/CoBranding/index'),
        name: 'CoBranding',
        meta: { title: '合作品牌管理', roles: ['admin','editor'], icon: 'icon-a-hezuo3', noCache: true }
      }
    ]
  }, {
    path: '/ownerFeedback',
    component: Layout,
    redirect: '/ownerFeedback/index',
    hidden: false,
    children: [
      {
        path: 'index',
        component: () => import('@/views/ownerFeedback/index'),
        name: 'OwnerFeedback',
        meta: { title: '业主反馈管理', roles: ['admin','editor'], icon: 'icon-xiaoxi1', noCache: true }
      }
    ]
  }, {
    path: '/houseService',
    component: Layout,
    redirect: '/houseService/index',
    hidden: false,
    children: [
      {
        path: 'index',
        component: () => import('@/views/houseService/index'),
        name: 'HouseService',
        meta: { title: '验房服务管理', roles: ['admin','editor'], icon: 'icon-icon-kccx', noCache: true }
      }
    ]
  }, {
    path: '/freeDesign',
    component: Layout,
    redirect: '/freeDesign/index',
    hidden: false,
    children: [
      {
        path: 'index',
        component: () => import('@/views/freeDesign/index'),
        name: 'FreeDesign',
        meta: { title: '预约设计管理', roles: ['admin','editor'], icon: 'icon-sheji1', noCache: true }
      }
    ]
  }, {
    path: '/couponManger',
    component: Layout,
    redirect: '/couponManger/index',
    hidden: false,
    children: [
      {
        path: 'index',
        component: () => import('@/views/couponManger/index'),
        name: 'CouponManger',
        meta: { title: '优惠券管理', roles: ['admin','editor'], icon: 'icon-jiedianyouhuiquan', noCache: true }
      }
    ]
  }, {
    path: '/supplierManager',
    component: Layout,
    redirect: '/supplierManager/index',
    hidden: false,
    children: [
      {
        path: 'index',
        component: () => import('@/views/supplierManager/index'),
        name: 'SupplierManager',
        meta: { title: '供应商管理', roles: ['admin','editor'], icon: 'icon-yonghuguanli1', noCache: true }
      }
    ]
  }, {
    path: '/DiyManager',
    component: Layout,
    redirect: '/DiyManager/brandManagement',
    hidden: false,
    meta: { title: '材料随心选管理', roles: ['admin','editor'], icon: 'icon-shouchufuwu', noCache: true },
    children: [
       {
        path: 'materialCategory',
        component: () => import('@/views/DiyManager/materialCategory'),
        name: 'MaterialCategory',
        meta: { title: '材料品类管理', roles: ['admin','editor'], icon: 'icon-fenlei', noCache: true }
      }, {
        path: 'brandManagement',
        component: () => import('@/views/DiyManager/brandManagement'),
        name: 'BrandManagement',
        meta: { title: '材料品牌管理', roles: ['admin','editor'], icon: 'icon-pinpaiguanli', noCache: true }
      }, {
        path: 'itemAttributesManage',
        component: () => import('@/views/DiyManager/itemAttributesManage'),
        name: 'itemAttributesManage',
        meta: { title: '材料分类管理', roles: ['admin','editor'], icon: 'icon-guanli', noCache: true }
      }, {
        path: 'materialManage',
        component: () => import('@/views/DiyManager/materialManage'),
        name: 'MaterialManage',
        meta: { title: '材料管理', roles: ['admin','editor'], icon: 'icon-cailiaoguanli2', noCache: true }
      }
    ]
    // children: [
    //   {
    //     path: 'index',
    //     component: () => import('@/views/DiyManager/index'),
    //     name: 'DiyManager',
    //     meta: { title: 'DIY装修管理', roles: ['admin','editor'], icon: 'icon-jiedianyouhuiquan', noCache: true },
        
    //   }
    // ]
  },
   {
    path: '/customerSelections',
    component: Layout,
    redirect: '/customerSelections/index',
    hidden: false,
    children: [
      {
        path: 'index',
        component: () => import('@/views/customerSelections/index'),
        name: 'CustomerSelections',
        meta: { title: '材料随心选记录管理', roles: ['admin','editor'], icon: 'icon-gouwucheman', noCache: true }
      }
    ]
  }, {
    path: '/announManage',
    component: Layout,
    redirect: '/announManage/index',
    hidden: false,
    children: [
      {
        path: 'index',
        component: () => import('@/views/announManage/index'),
        name: 'AnnounManage',
        meta: { title: '公告管理', roles: ['admin','editor'], icon: 'icon-gonggao', noCache: true }
      }
    ]
  }, {
    path: '/diaryManage',
    component: Layout,
    redirect: '/diaryManage/index',
    hidden: false,
    children: [
      {
        path: 'index',
        component: () => import('@/views/diaryManage/index'),
        name: 'DiaryManage',
        meta: { title: '装修日记管理', roles: ['admin','editor'], icon: 'icon-zhuangxiuriji', noCache: true }
      }
    ]
  }, {
    path: '/pointManagement',
    component: Layout,
    redirect: '/pointManagement/index',
    hidden: false,
    children: [
      {
        path: 'index',
        component: () => import('@/views/PointManagement/index'),
        name: 'PointManagement',
        meta: { title: '积分管理', roles: ['admin','editor'], icon: 'icon-jifenguanli1', noCache: true }
      }
    ]
  }
  // {
  //   path: '/profile',
  //   component: Layout,
  //   redirect: '/profile/index',
  //   hidden: false,
  //   children: [
  //     {
  //       path: 'index',
  //       component: () => import('@/views/profile/index'),
  //       name: 'Profile',
  //       meta: { title: 'Profile', icon: 'list', noCache: true }
  //     }
  //   ]
  // }
]

/**
 * asyncRoutes
 * the routes that need to be dynamically loaded based on user roles
 */
export const asyncRoutes = [
  /** when your routing map is too long, you can split it into small modules **/
  // chartsRouter,
  // tableRouter,

  // {
  //   path: '/example',
  //   component: Layout,
  //   redirect: '/example/list',
  //   name: 'Example',
  //   meta: {
  //     title: 'Example',
  //     icon: 'el-icon-s-help'
  //   },
  //   children: [
  //     {
  //       path: 'create',
  //       component: () => import('@/views/example/create'),
  //       name: 'CreateArticle',
  //       meta: { title: 'Create Article', icon: 'edit' }
  //     },
  //     {
  //       path: 'edit/:id(\\d+)',
  //       component: () => import('@/views/example/edit'),
  //       name: 'EditArticle',
  //       meta: { title: 'Edit Article', noCache: true, activeMenu: '/example/list' },
  //       hidden: true
  //     },
  //     {
  //       path: 'list',
  //       component: () => import('@/views/example/list'),
  //       name: 'ArticleList',
  //       meta: { title: 'Article List', icon: 'list' }
  //     }
  //   ]
  // },

  // 404 page must be placed at the end !!!
  { path: '*', redirect: '/404', hidden: true }
]

const createRouter = () => new Router({
  // mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

const router = createRouter()
// 添加一个标志，防止重复导航

router.beforeEach((to, from, next) => {
  NProgress.start()
  const hasToken = getToken()
  
  if (hasToken) {
    to.path === '/login' ? next('/') : next()
  } else {
    to.path === '/login' ? next() : next(`/login?redirect=${to.path}`)
  }
})

router.afterEach(() => {
  NProgress.done()
})

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router
